<div class="d-flex h-100 position-relative" style="width: -webkit-fill-available">
    <div class="gift-box d-flex flex-column justify-content-between bg-white" [id]="gift.giftId"
        style="width: -webkit-fill-available; border: 1px solid #DEE2E6; border-radius: 12px;">

        <div class="gift-image">
            <!-- Ảnh quà -->
            <div style="display: flex; justify-content: center; margin-bottom: 24px;">
                <a class="product-image" style="cursor: pointer;" (click)="openGiftDetail();">
                    <img [src]="gift.imageUrls?.[0]" class="img-fluid d-flex"
                        style="padding: 16px;" [alt]="gift.name"  loading="lazy" />
                </a>
            </div>

            <!-- Tên quà -->
            <div class="name" style="cursor: pointer;" (click)="openGiftDetail()">{{ gift.name }}</div>
        </div>

        <div class="gift-detail">
            <div class="d-flex flex-column gap-1">
                <!-- Số lượng đã đổi -->
                <div class="exchanged-date">Số lượng: {{ gift.exchangedQuantity }}</div>
            </div>

            <div class="product-box-3 p-0 bg-white" style="margin-top: 24px;">
                <div class="pb-2">Số lượng trong giỏ: {{ gift.quantity }}</div>
                <div class="add-to-cart-box">
                    <!-- <button *ngIf="!gift.inCart" class="btn btn-solid rounded-3 w-100 btn-exchange" (click)="updateGiftCart(gift, 1)">
                        Thêm vào giỏ
                    </button>
                    <button *ngIf="gift.inCart" class="btn btn-solid rounded-3 w-100 btn-remove" (click)="updateGiftCart(gift, 0)">
                        Bỏ chọn
                    </button> -->
                    <div class="cart_qty qty-box open position-relative">
                        <div class="input-group">
                            <app-counter
                                style="width: 100%"
                                [giftItem]="gift"
                                [isGift]="true">
                            </app-counter>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-gift-detail #giftDetail [giftId]="gift.giftId" [isExchanged]="true"></app-gift-detail>
<!-- <app-product-detail-image-modal #productDetailImageModal [title]="gift.name" [images]="gift.imageUrls">
</app-product-detail-image-modal> -->